// removed by extract-text-webpack-plugin
module.exports = {"container":"container_UserReport","entrance":"entrance_UserReport","btn":"btn_UserReport","report":"report_UserReport","btn-text":"btn-text_UserReport","btnText":"btn-text_UserReport"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserReport/UserReport.scss
// module id = 300
// module chunks = 0